

import React, { Component, Fragment } from 'react';
import MediaQuery from 'react-responsive'

class DesktopComponent extends Component 
{
    render()
    {
        return <Fragment>
                    <MediaQuery minWidth={1224}>
                        {this.props.desktop}
                    </MediaQuery>

                    <MediaQuery maxWidth={1224}>
                        {this.props.mobile}
                    </MediaQuery>
                </Fragment>
    }
}

export default DesktopComponent;